import AmioCachedHttpService from './amio-cached-http.service'
import isEmpty from 'ramda/src/isEmpty'
import requestOutcomeMapper from '@/utils/request-outcome.mapper'

class AnalyticsService extends AmioCachedHttpService {

  async getRequestOutcomes({ botId, dateFrom, dateTo, channels }) {
    const path = '/analytics/request-outcomes'
    const params = this._getRequestOutcomeParams({ botId, dateFrom, dateTo, channels })

    try {
      const response = await this.requestGet(path, { params })
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  _getRequestOutcomeParams({ botId, dateFrom, dateTo, channels }) {
    const params = {}
    const stringParams = { botIds: botId, dateFrom, dateTo }
    Object.keys(stringParams).forEach((key) => {
      if (stringParams[key]) {
        params[key] = stringParams[key]
      }
    })

    if (channels) params.channelIds = channels.join(',')

    return params
  }

  async getConversations({ botId, from, to, outcomes, resolutions, ignoreOutcomes, answerId, cursor, channels }) {
    const params = this._getConversationParams(
      { botId, from, to, outcomes, resolutions, ignoreOutcomes, answerId, cursor, channels }
    )
    try {
      const response = await this.requestGet('/analytics/conversations', { params })
      return {
        conversations: response.data.conversations, cursor: response.data.cursor
      }
    } catch (err) {
      throw this.handleError(err)
    }
  }

  _getConversationParams({ botId, from, to, outcomes, resolutions, ignoreOutcomes, answerId, cursor, channels }) {
    const params = {
      botIds: botId, dateFrom: from, dateTo: to, max: 30
    }
    if (outcomes) {
      const mappedOutcomes = requestOutcomeMapper.mapLegendsToOutcomes(outcomes)
      params.requestOutcomes = mappedOutcomes.join(',')
    } else if (resolutions) {
      const ignoredOutcomes = requestOutcomeMapper.getIgnoreOutcomes(resolutions, 'assistanceResolutions')
      params.ignoreOutcomes = ignoredOutcomes.join(',')
    }

    if (ignoreOutcomes) params.ignoreOutcomes = ignoreOutcomes.join(',')

    if (answerId) params.answerId = answerId

    if (!isEmpty(cursor)) {
      params.cursorTimestamp = cursor.next_timestamp
      params.cursorContactId = cursor.next_contact_id
    }

    if (channels) params.channelIds = channels.join(',')

    return params
  }

  getConversationHistory(contactId, cursor = null, max = 100) {
    const params = { max }
    if (cursor) params.cursor = cursor
    return this.requestGet(`/analytics/conversations/${contactId}/history`, { params })
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }

  getConversationRequests(contactId) {
    return this.requestGet(`/analytics/conversations/${contactId}/requests`)
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }
}

export default new AnalyticsService()
